export function loadMstv( wrapper, clearBtn, edtn, isMstv) {
  if (!isMstv || (isMstv && edtn !== 'de' && edtn !== 'ev_de')) {
        wrapper[0].addEventListener('click', (event) => {
            wrapper.html('<div class="video-player-close icon-cross">' + clearBtn + '</div><iframe allowfullscreen frameborder="0" allow="autoplay" src="' + wrapper.data('video-url') + '"></iframe>');
        });
    } else {
        console.log('inside else mstv-player');
        //wrapper.innerHTML = '<div class="video-player-close icon-cross">' + clearBtn + '</div><iframe allowfullscreen frameborder="0" allow="autoplay" src="' + wrapper.attr('data-video-url') + '"></iframe>';
        wrapper.html('<div class="video-player-close icon-cross">' + clearBtn + '</div><iframe allowfullscreen frameborder="0" allow="autoplay" src="' + wrapper.data('video-url') + '"></iframe>');

    }
}
